import React from "react"
import "./Comercializadora-Casar.css"
import TitleDisplayerComponent from "../TitleDisplayer/titledisplayer"
import { useInView } from "react-intersection-observer";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
function ComercializadoraCasar(){

    const history = useHistory();

    const {ref:CCText, inView:CCTextIsVisible}= useInView({
        "threshold":.5,
        "initialInView": "true"
    });
    const {ref:CCWrap, inView:CCWrapIsVisible}= useInView({
        "threshold":.1,
        "initialInView": "true"
    });
    const {ref:imagen2, inView:Image2IsVisible} = useInView({
        // triggerOnce:true
          "threshold": .75,
          "initialInView":true
      });
      const {ref:catalogo, inView:CatalogoIsVisible} = useInView({
          "threshold": .75,
          "initialInView":true
      });
    

    return (<>
            <div ref={CCWrap} class={`contentComercializadora ${CCWrapIsVisible ? "CCAnimation" : ""}`} id="comercializadora">
            
                <div className="ComercializadoraFlexWrap">
                <div className="ImageWrapComercializadora">
                        <div className="ComercializadoraImageEmpresa">
                            <img src="./Images/Encabezado CASAR-01.png" ref={imagen2} className={`imgSizeComercializadora ${Image2IsVisible ? "imgSizeComercializadoraAnimated":""}`} alt="" />
                        </div>
                    </div>
                    <div class="WrapTextComercializadora">
                        <div class="titleComercializadora">
            
                                <TitleDisplayerComponent text="Comercializadora CASAR"/>
            
                            </div>
                        <h4  ref={CCText} className={`TxtContentComercializadora ${CCTextIsVisible ? "TxtContentComercializadoraAnimated" : "" }`}>
                        Contamos con equipo de las mejores marcas para hoteles, restaurantes, cafeterías, carnicerías, panaderías, mini súpers, etc.
                      Nuestra amplia gama de productos incluyen básculas, esftufas,
                      hornos, freezers, batidoras, vitrinas refrigeradas, molinos, entre
                      muchos más.<br/>
                      Contáctanos y solicita más información o compra en línea y tu pedido llegará a domicilio. Ten la confianza de que tu compra esta protegida,
                      ya que nuestro sitio cuenta con los mayores estándares de seguridad para el usuario. </h4>
                            <div className="verCatalogo">
            
                                <button ref={catalogo} onClick={() => history.push('/catalogo')} className={`VerCatalogoTxt ${CatalogoIsVisible ? "CatalogoAnimated" : ""}`}>Ver Catálogo</button>
                           </div>
                    </div>
                </div>
            </div>
    </>
    );
}

export default ComercializadoraCasar